var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_275_26190",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 14,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12637 0H18V18H4.12637V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_275_26190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80964 0.892669L4.23896 2.08262L7.80964 3.27258L4.23896 4.46334L7.80964 5.6533L4.23896 6.84406L7.80964 8.03402L4.23815 9.22478L7.80883 10.4147L4.23815 11.6055L7.80883 12.7955L4.23815 13.9854L7.80883 15.1762L4.23815 16.3661L7.80883 17.5561L6.98096 17.7635C7.63062 17.9133 8.30458 18 8.99959 18C13.97 18 18 13.97 18 8.99959C18 4.02916 13.97 0 8.99959 0C7.99676 0 7.03524 0.170919 6.13447 0.473876L7.80964 0.892669Z",
    fill: "#880E4F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_275_26190",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.445312H7.85905V17.8645H0V0.445312Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_275_26190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.23815 16.3667L7.80883 15.1759L4.23815 13.986L7.80883 12.7952L4.23815 11.6053L7.80883 10.4153L4.23815 9.22454L7.80883 8.03378L4.23815 6.84382L7.80883 5.65387L4.23815 4.4631L7.80883 3.27315L4.23815 2.08319L7.80883 0.892426L6.13366 0.473633C2.57027 1.67088 0 5.03175 0 8.99935C0 13.2748 2.98339 16.8463 6.98096 17.7632L7.80883 17.5567L4.23815 16.3667Z",
    fill: "#ECEFF1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQatar);
export default __webpack_public_path__ + "static/media/Qatar.8dad5ba876fb93c8b9b1ef0b3fb4f1d5.svg";
export { ForwardRef as ReactComponent };